module.exports = __webpack_public_path__ + "static/media/alpine.a163feb3.svg";